<template>
	<div class="bottom-order-editor">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="v => $emit('toggling-popup', v)" >
			<div class="order-edit-content" v-if="active">
				<ModalHeader :title="getString('order_edit')" />
				<AppList :items="items">
					<template #textarea-slot="{item}">
						<div class="row textarea-list-item">
							<div class="title"><p>{{ item.title }}</p></div>
							<div class="cta-container">
								<AppTextInput
									:placeholder="getString('order_notes')"
									:value="counterStore.orderNotes ? counterStore.orderNotes : ''"
									textarea auto-grow
									@changing-text="item.callback"
								/>
							</div>
						</div>
					</template>
					<template #customers-slot="{item}">
						<div class="row centered space-between button-slot">
							<p class="list-item-title">{{ item.title }}</p>
							<AppButton outline small :text="item.button_text" @click="item.callback" :disabled="item.disabled" />
						</div>
						<CustomersDisplay />
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
		<CustomersPicker :active="customerPicker" @toggling-popup="togglingCustomersPicker" @picked-customer="pickedCustomer" />
	</div>
</template>

<script>

import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useCounterStore} from "@/console-new/stores/counter.store";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import CustomersPicker from "@/console-new/components/ops/CustomersPicker.vue";
import CustomersDisplay from "@/console-new/components/ops/CustomersDisplay.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const counterStore = useCounterStore();
		const svgStore = useSvgStore();
		return {getString: languageStore.getString, counterStore, svgStore};
	},
	name: "BottomOrderEditor",
	components: {CustomersDisplay, CustomersPicker, AppButton, AppTextInput, AppList, ModalHeader, AppBottomSheet},
	mixins: [WindowWidth],
	emits: ["toggling-popup"],
	props: {
		active: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			customerPicker: false,
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		items() {
			let items = [];

			if(!this.counterStore.editOrder) {
				items.push({
					title: this.getString("associate_customer"),
					customSlot: "customers-slot",
					button_text: this.getString("customer"),
					callback: () => this.customerPicker = true,
				});
			}
			items.push({
				title: this.getString("order_notes"),
				customSlot: "textarea-slot",
				callback: (v) => this.counterStore.orderNotes = v,
			});
			items.push({
				title: this.getString("clear_order"),
				buttonTitle: this.getString("clear"),
				buttonDisabled: this.counterStore.cartItemsCount === 0,
				callbackButton: this.clearOrder,
			});

			return items;
		}
	},
	methods: {
		togglingCustomersPicker(v) {
			if(!v) {
				this.customerPicker = false;
			}
		},
		pickedCustomer(customer) {
			this.customerPicker = false;
			this.counterStore.selectedCustomer = customer;
		},
		clearOrder() {
			this.counterStore.clearCart();
			this.$emit("toggling-popup", false);
		}
	},
}
</script>

<style scoped lang="scss">
.list-item-title {
	max-width: calc(100% - 105px);
	font-size: 16px;
}
.textarea-list-item {
	.title { width: calc(100% - 285px); }
	.cta-container { width: 285px; }
}
.textarea-list-item {
	@include noSelect;
	align-items: center;
	justify-content: space-between;
	.title p {
		width: 100%;
		line-height: 16px;
		text-align: left;
	}
	.cta-container {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}
.button-slot {
	gap: 10px;

	.base-button {
		margin-left: auto;
	}
}
</style>